import { Link } from "react-router-dom";
import "../pages/css/App.css";

function PrivacyPolicy() {
  return (
    <div className="login-container">
      <div className="privacy-box">
        <h1>Datenschutzerklärung</h1>
        <h2>Datenschutzerklärung für die private App</h2>
        <p>
          Diese App wird privat betrieben und ist ausschließlich für eingeladene
          Nutzer zugänglich. Eine Registrierung ist nur über einen persönlichen
          Einladungslink möglich. Menschen bauen inzwischen selbst für den
          Freundeskreis komplette Webplattformen. Früher hat man einfach einen
          Grillabend organisiert. Fortschritt, nehme ich an.
        </p>

        <hr className="privacy-divider" />

        <h3>1. Verantwortlicher</h3>
        <p>Verantwortlich für den Betrieb dieser App ist:</p>
        <p>
          Thomas Kotzur
          <br />
          webmaster@dram.moosetv.de
        </p>

        <hr className="privacy-divider" />

        <h3>2. Zweck der Verarbeitung</h3>
        <p>
          Die Verarbeitung personenbezogener Daten erfolgt ausschließlich zum
          Betrieb der App und zur Bereitstellung der angebotenen Funktionen.
        </p>

        <hr className="privacy-divider" />

        <h3>3. Verarbeitete Daten</h3>
        <p>Im Rahmen der Nutzung können folgende Daten verarbeitet werden:</p>
        <ul>
          <li>Registrierungsdaten (z. B. Benutzername)</li>
          <li>
            Technische Verbindungsdaten (z. B. IP-Adresse, Zeitpunkt des
            Zugriffs)
          </li>
          <li>Inhalte, die Nutzer innerhalb der App selbst einstellen</li>
        </ul>

        <hr className="privacy-divider" />

        <h3>4. Registrierung und Einladungssystem</h3>
        <p>
          Die Registrierung ist ausschließlich über einen gültigen
          Einladungslink möglich. Dadurch wird der Nutzerkreis bewusst
          eingeschränkt und die App nicht öffentlich zugänglich gemacht.
        </p>

        <hr className="privacy-divider" />

        <h3>5. Rechtsgrundlage</h3>
        <p>
          Die Verarbeitung erfolgt gemäß Art. 6 Abs. 1 lit. b DSGVO zur
          Bereitstellung der App sowie gemäß Art. 6 Abs. 1 lit. f DSGVO auf
          Grundlage des berechtigten Interesses an einem sicheren und privaten
          Betrieb der Plattform.
        </p>

        <hr className="privacy-divider" />

        <h3>6. Weitergabe von Daten</h3>
        <p>
          Eine Weitergabe personenbezogener Daten an Dritte erfolgt
          grundsätzlich nicht, außer wenn dies gesetzlich vorgeschrieben ist
          oder technisch für den Betrieb erforderlich ist (z. B.
          Hostinganbieter).
        </p>

        <hr className="privacy-divider" />

        <h3>7. Speicherung und Löschung</h3>
        <p>
          Personenbezogene Daten werden nur so lange gespeichert, wie dies für
          den Betrieb der App erforderlich ist oder gesetzliche
          Aufbewahrungspflichten bestehen.
        </p>

        <hr className="privacy-divider" />

        <h3>8. Rechte der Nutzer</h3>
        <p>Nutzer haben im Rahmen der DSGVO insbesondere folgende Rechte:</p>
        <ul>
          <li>Auskunft über gespeicherte Daten</li>
          <li>Berichtigung unrichtiger Daten</li>
          <li>Löschung der Daten</li>
          <li>Einschränkung der Verarbeitung</li>
          <li>Widerspruch gegen die Verarbeitung</li>
        </ul>
        <p>
          Anfragen können an die oben genannte Kontaktadresse gerichtet werden.
        </p>

        <hr className="privacy-divider" />

        <h3>9. Sicherheit</h3>
        <p>
          Es werden technische und organisatorische Maßnahmen eingesetzt, um die
          Daten vor Verlust, Missbrauch oder unbefugtem Zugriff zu schützen.
          Zumindest soweit Menschen das jemals wirklich hinbekommen haben. Das
          Internet bleibt ein glorifizierter Kabelsalat mit Zertifikaten.
        </p>

        <hr className="privacy-divider" />

        <h3>10. Änderungen</h3>
        <p>
          Diese Datenschutzerklärung kann bei Bedarf angepasst werden, um
          rechtliche oder technische Änderungen zu berücksichtigen.
        </p>

        <div className="privacy-footer">
          <Link className="privacy-link" to="/login">
            Zurück zur Anmeldung
          </Link>
        </div>
      </div>
    </div>
  );
}

export default PrivacyPolicy;
